export const DEFAULT_CHAT_TITLE = "新規チャット";
